/**
 * Custom JavaScript - OxidProdutos
 * Fix: garante que produtos com estoque negativo aparecem na busca
 */

// Intercepta fetch e XMLHttpRequest para forçar unavailable_products=show em todas as buscas
(function() {
  // Fix para fetch (usado por temas modernos)
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/search') !== -1) {
      url = url.replace(/options%5Bunavailable_products%5D=hide/gi, 'options%5Bunavailable_products%5D=show');
      url = url.replace(/options%5Bunavailable_products%5D=last/gi, 'options%5Bunavailable_products%5D=show');
      url = url.replace(/options\[unavailable_products\]=hide/gi, 'options[unavailable_products]=show');
      url = url.replace(/options\[unavailable_products\]=last/gi, 'options[unavailable_products]=show');
      if (url.indexOf('unavailable_products') === -1) {
        url += (url.indexOf('?') !== -1 ? '&' : '?') + 'options%5Bunavailable_products%5D=show';
      }
    }
    return originalFetch.apply(this, [url, options]);
  };

  // Fix para XMLHttpRequest (usado por temas legados como dropmeta)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && url.indexOf('/search') !== -1) {
      url = url.replace(/options%5Bunavailable_products%5D=hide/gi, 'options%5Bunavailable_products%5D=show');
      url = url.replace(/options%5Bunavailable_products%5D=last/gi, 'options%5Bunavailable_products%5D=show');
      url = url.replace(/options\[unavailable_products\]=hide/gi, 'options[unavailable_products]=show');
      url = url.replace(/options\[unavailable_products\]=last/gi, 'options[unavailable_products]=show');
      if (url.indexOf('unavailable_products') === -1) {
        url += (url.indexOf('?') !== -1 ? '&' : '?') + 'options%5Bunavailable_products%5D=show';
      }
    }
    return originalOpen.apply(this, arguments);
  };
})();

// Código original do tema
var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  window.onscroll = function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }
}

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}

$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});